/* CUSTOM CURSOR */
const cursor = document.createElement('div');
cursor.classList.add('cur');

document.body.appendChild(cursor);

const ring = document.createElement('div');
ring.classList.add('cur-ring');

document.body.appendChild(ring);

let mouseX = 0;
let mouseY = 0;
let ringX = 0;
let ringY = 0;

window.addEventListener('mousemove', (e) => {
  mouseX = e.clientX;
  mouseY = e.clientY;

  cursor.style.left = mouseX + 'px';
  cursor.style.top = mouseY + 'px';
});

function animateRing(){
  ringX += (mouseX - ringX) * 0.12;
  ringY += (mouseY - ringY) * 0.12;

  ring.style.left = ringX + 'px';
  ring.style.top = ringY + 'px';

  requestAnimationFrame(animateRing);
}

animateRing();

/* SCROLL REVEAL */
const revealElements = document.querySelectorAll('.reveal-up');

function revealOnScroll(){

  revealElements.forEach((element) => {

    const top = element.getBoundingClientRect().top;

    if(top < window.innerHeight - 100){
      element.classList.add('active');
    }

  });

}

window.addEventListener('scroll', revealOnScroll);
window.addEventListener('load', revealOnScroll);



const hoverItems = document.querySelectorAll('a, button');

hoverItems.forEach(item => {

  item.addEventListener('mouseenter', () => {
    document.querySelector('.cur-ring').classList.add('active');
  });

  item.addEventListener('mouseleave', () => {
    document.querySelector('.cur-ring').classList.remove('active');
  });

});